module.exports = {
    checkQuotes: function (quote) {
        if(parseInt(quote) === 0 ){
            html = '<span class="disabled-bet">--</span>';
            return html;
        } else {
            return quote.toFixed(2);
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/globalFunctions.js
// module id = 29
// module chunks = 4